<template>
  <div class="row">
      <div class="col-md-offset-1 col-md-10 col-xs-10 col-xs-offset-1">
           <!-- <input placeholder="Search for stuff here. Literally anything. We use Elastic now."  type="text" class="validate"> -->
           <md-input-container>
            <md-input id="search" placeholder="Search for internships, positions and just about anything" @keyup.enter.native="greet" v-model="searchString"></md-input>
          </md-input-container>
      </div>
      <div class="col-md-12 col-xs-12" style="margin-bottom:20px;"><md-button  class="search-btn" v-on:click="greet">SEARCH</md-button>

    </div>

    <!-- <div class="col-md-8 col-md-offset-2 preloader" id="preloader" style="display:none;"><md-progress class="md-warn"  md-indeterminate></md-progress></div> -->

      <div class="row col-md-4 col-xs-3  col-md-offset-5 col-sm-offset-5 col-xs-offset-4" id="preloader" style="display:none; float:left">
          <div class="col-md-offset-1">
            <circle8 size="100px"></circle8>
          </div>
      </div>



      <div v-for="index in results" class="search-result col-lg-4 col-md-6 col-xs-12">
           <md-card style="background-color:" class="md-primary" flex md-with-hover md-elevation="15">
              <md-card-header>
                <div class="md-title">{{ index.organisation }}</div>
                <div class="md-subhead" style="font-weight:bold;">
                  Commitment: {{ index.commitment }} <br>
                </div>
                <div class="md-subhead" style="font-weight:bold;">
                  City: {{index.city}} <br>
                </div>
              </md-card-header>



              <md-card-expand class="margT">
                <!-- Don't remove this, somehow makes the buttons align properly -->
              </md-card-expand>
              <md-card-expand>
                <md-card-actions>
                  <md-button v-bind:href="index.form" target="_blank" class="theme">Apply</md-button>
                  <md-button md-expand-trigger class="theme">
                    More Info
                  </md-button>
                  <span style="flex: 1"></span>

                </md-card-actions>

                <md-card-content>
                    {{ index.description }}
                </md-card-content>
              </md-card-expand>
          </md-card>
      </div>

        <md-button class="md-fab md-mini md-clean md-fab-bottom-right" id="hideBtn" v-on:click="clear" style="display:none;">
          <md-icon>close</md-icon>
        </md-button>

  </div>




</template>
<script>
import {db} from './firebase'

import Fuse from 'fuse.js'
import Vue from 'vue'
import VueMaterial from 'vue-material'
// import VuePaginator from 'vuejs-paginator'
import Circle8 from 'vue-loading-spinner/src/components/Circle8.vue'
import 'vue-material/dist/vue-material.css'
Vue.use(VueMaterial)

var mumbaiRef = db.ref('Mumbai')


var oppArray = [];

var query = mumbaiRef.orderByKey();

query.once("value")
  .then(function(snapshot) {
    snapshot.forEach(function(childSnapshot) {
      var oppKey = childSnapshot.key
      var address = childSnapshot.child('Address').val();
      var organisation = childSnapshot.child('Organisation').val();
      var category = childSnapshot.child('Category').val();
      var commitment = childSnapshot.child('Commitment').val();
      var form = childSnapshot.child('Form').val();
      var description = childSnapshot.child('Description').val();
      var city = childSnapshot.child('City').val();
      // oppArray.push({'Organisation':organisation, 'Category': category, 'Commitment':commitment, 'Form':form, 'Description':description, oppKey})
      // oppArray.push(oppKey)
      oppArray.push({address, organisation, category, commitment, form, description, city, oppKey})

  });
  //console.log(oppArray)
});
// console.log(oppArray)

// console.log(Vue.$children)
export default {
  name: 'search',
  components: {
     Circle8
   },
  //defines empty thing really important
  data: () => ({
    results: {},
    searchString: '',

  }),

  methods: {
    greet: function (event) {
    document.getElementById('preloader').style.display = 'block';
    this.results=[]
    setTimeout(this.afterLoading, 3000);


  },
  afterLoading: function() {

    document.getElementById('preloader').style.display = 'none';

    var options = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: [
      "address",
      "description",
      "organisation",
      "city",
      "category"
  ]

  };

  var fuse = new Fuse(oppArray, options); // "list" is the item array
    this.results = fuse.search(this.searchString);
    document.getElementById('hideBtn').style.display = 'block';
  },
  clear: function(event) {
    this.results = []
    document.getElementById('hideBtn').style.display = 'none';
    // document.getElementById('heading').style.display = 'none';
    this.searchString = '';
  }
  }

};
</script>


<style scoped>
.search-result{
  /*margin-top:20px;*/
  color:black;
  /*border: 2px white solid;*/
  padding:5px;
}
.md-theme-default.md-card.md-primary {
  background-color: white;
}

.md-card{
  /*background-image: url('https://static.pexels.com/photos/497848/pexels-photo-497848.jpeg');*/
  margin-top:0.5%;
  margin-bottom: 1%;
  color: black;
  text-align: left;
  min-height: 200px;

}

.md-card-actions{
  margin-bottom: 0px;
  color: black;
  padding:25px;
  padding-bottom: 0px;
  text-align: left;
}
.md-card .md-card-actions .md-button {
  color: black;
  border: 1px white solid;
}
.md-card-content{
  /*background-color: black;*/
  background-color: white;
  color: black;
  font-size: 20px;
}
.md-card-expand p{
  font-size: 1em;
}
.md-theme-default.md-card .md-card-expand .md-card-actions {
    /*background-color: transparent;*/
    background-color: white;
    margin-top:0px;
    color: black;
}
.md-chip{
  color: white;
  background-color: transparent;
  margin-top:1%;
  text-transform: uppercase;
}
.md-input-focused:active{
  border-bottom: none;
}
#search{
  text-align: center;
  color: black;
  font-size: 20px;
  border: 1px solid white;
  background-color: none;
  border-radius: 3px;
  height:50px;
}
.md-theme-default.md-input-container.md-input-focused input, .md-theme-default.md-input-container.md-input-focused textarea{
  border-bottom: 1px solid black !important;
}
.col-md-12,.col-xs-12{
  text-align: center;
}
.md-button, .md-input{
  text-align: center;
  color: black;
}
.md-button{
  width:30%;
  background-color: transparent;
  border: 1px transparent solid;
  color: black;
  font-size: 1.2em;
}

.search-btn{
  text-align: center;
  border: 1px solid #05668d;
  width:15%;
  color: #05668d;
  border-radius: 5px;
}
.md-card .md-card-header{
  color: black;
}
::-webkit-input-placeholder { /* WebKit browsers */
    color: grey;
    opacity: 1 !important;
    font-size: 2em;
}
.search-btn:hover{
  background-color: rgba(0,0,0,0.2);
  color:#05668d;
  border-radius: 20px;
}
.theme{
  background-color:transparent;
  color : #ebf2fa;
  border:1px solid #ebf2fa;
  width:50%;
}
.margT{
  margin-top:40px;
}
.MargB{
  margin-bottom:60px;
}


h3{
  font-size:4.5em;
}
.title-text{
  text-align: center;
  margin-top:13%;
  margin-bottom:30px;
  color: #05668d;
  font-family: 'Alegreya Sans SC', sans-serif;
  color: #05668d;
  text-align: center;
  font-weight: lighter;

}

/* Responsive text */
@media only screen and (max-width: 600px) {
  h3{
      font-size:3.0em;
  }
}
hr{
  web-shadow:none;
  border: 1px solid #D4D4D4;
  margin:0px;
  width:100%;
  text-align: center;
}
.md-fab-bottom-right{
  width:25%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// Search.vue?8923f24a